import { render } from "./Absence.vue?vue&type=template&id=42e20078"
import script from "./Absence.vue?vue&type=script&lang=js"
export * from "./Absence.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__